import {
    AlertTypes,
    GenericFormContainer,
    IAlertData,
    Leap4Breadcrumbs, Mode,
    Spinner,
    apiClient,
    MuiIcons
} from "@leap4/frontend";
import {EditPublisherLoginsStore} from "./EditPublisherLoginsStore";
import {useParams} from "react-router-dom";
import {useEffect, useMemo, useState} from "react";
import {PublisherLoginsBaseUrl} from "../../../../config/generals";
import {RootState} from "../../../../store/store";
import {connect, ConnectedProps, useDispatch} from "react-redux";
import {urlService} from "../../../routing/urlsService";
import {DetailsForm} from "../DetailsForm";
import { PublisherLoginContext } from "../PublisherLoginContex";
import {IPublisherLogins} from "../../interfaces/IPublisherLogins";
import {initialPublisherLoginObj} from "../PublisherLogin";
import {setAlert} from "../../../../actions/alert";
import {updatePartners} from "../../../../actions/users";

const {Toc: TocIcon, Groups: GroupsIcon} = MuiIcons;

const mapStateToProps = (state: RootState) => ({});

const mapActions = {
    setAlert
}

export interface IEditGroupProps extends PropsFromRedux {
    setGroup: (data: IAlertData) => void;
    setAlert: any;
}

const connector = connect(mapStateToProps, mapActions);
type PropsFromRedux = ConnectedProps<typeof connector>;

let editPublisherLoginsStore: EditPublisherLoginsStore


const _editPublisherLogins = (props: IEditGroupProps) => {
    const {setGroup, setAlert} = props
    const dispatch = useDispatch();
    const params = useParams<{ id?: string }>();
    const [publisherLogin, setPublisherLogin] = useState<IPublisherLogins>(initialPublisherLoginObj);
    const PLContextValue = useMemo(() => ({publisherLogin, setPublisherLogin}), [publisherLogin]);
    const [isLoading, setIsLoading] = useState(false)
    const [isLoadError, setIsLoadError] = useState(false)

    const onSubmit = async () => {
        if (!publisherLogin.supplyPartners.length) {
            setAlert("No partners piked", AlertTypes.FAILURE)
            return;
        }
        setIsLoading(true)
        await updatePartners(dispatch, publisherLogin)
        setAlert("Updated", AlertTypes.SUCCESS)
        setIsLoading(false)
    };

    const fetchData = async (id: string) => {
        editPublisherLoginsStore = await new EditPublisherLoginsStore({
                setIsLoading,
                setIsLoadError,
                setItem: setPublisherLogin,
                axiosClient: apiClient,
                alertFunc: setGroup,
                baseUrl: `${PublisherLoginsBaseUrl}`
            }
        )
        return await editPublisherLoginsStore.refreshItem(id);
    }

    useEffect(() => {
        if (!params.id) {
            return;
        }
        (async () => {
            try {
                setIsLoading(true);
                await fetchData(params.id)
            } catch (e) {
                setAlert("Error connecting to database", AlertTypes.FAILURE)
            } finally {
                setIsLoading(false);
            }
        })()
    }, [params.id])

    if (isLoadError) {
        return (<>Error Loading the page</>);
    }
    if (isLoading) {
        return (<Spinner/>);
    }
    return (
        <>
            <Leap4Breadcrumbs breadcrumbs={[{
                text: "Publisher logins Dashboard",
                link: urlService.publisherLogins(),
                icon: <GroupsIcon/>
            },{
                text: publisherLogin?.advertiserName,
                link: urlService.organizations() + "/" + publisherLogin?.advertiserId,
                icon: <TocIcon/>
            },{
                text: publisherLogin?.publisherName,
                link: urlService.organizations() + "/" + publisherLogin?.publisherId,
                icon: <TocIcon/>
            },
            ]}
            />
            <GenericFormContainer mode={Mode.Edit} onCreateOrEditFunc={onSubmit} buttonsProps={{delete: {"disabled":true}}}>
            <PublisherLoginContext.Provider value={PLContextValue}>
                <DetailsForm mode={"edit"} />
            </PublisherLoginContext.Provider>
        </GenericFormContainer>
        </>
    )
}

export const editPublisherLogins = connect(mapStateToProps, {
    setAlert
})(_editPublisherLogins);